module.exports = [
  {
    key: 'AVULSION_SKIN_TEAR_MEDIUM',
    category: 'AVULSION',
    variation: 'AVULSION',
    label: { en: 'Avulsion', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AVULSION/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AVULSION/thumbs/${location}.png',
    },
    displayOrder: 2,
    locations: ['FACE', 'RIGHT_HAND', 'LEFT_HAND', 'RIGHT_FOOT', 'LEFT_FOOT'],
  },
  {
    key: 'ABRASION_SEVERE_LARGE',
    category: 'ABRASION',
    variation: 'SEVERE',
    label: { en: 'Large', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/ABRASION_SEVERE_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/ABRASION_SEVERE_LARGE/thumbs/${location}.png',
    },
    displayOrder: 2,
    locations: [
      'HEAD',
      'FACE',
      'NECK',
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'ABRASION_SEVERE_MEDIUM',
    category: 'ABRASION',
    variation: 'SEVERE',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/ABRASION_SEVERE_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/ABRASION_SEVERE_MEDIUM/thumbs/${location}.png',
    },
    displayOrder: 1,
    locations: [
      'HEAD',
      'FACE',
      'NECK',
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'DISTENSION_LARGE',
    category: 'GASTRIC DISTENSION',
    variation: 'LARGE',
    label: { en: 'Large', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/DISTENSION_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/DISTENSION_MEDIUM/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 2,
    locations: ['ABDOMEN'],
    stanceRestrictions: {
      'ABDOMEN': [ 'PRONE' ]
    },
  },
  {
    key: 'DEGLOVING_DIGITS',
    category: 'DEGLOVING',
    variation: 'DEGLOVING_DIGITS',
    label: { en: 'Degloving Digits', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/DEGLOVING_DIGITS/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/DEGLOVING_DIGITS/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 1,
    locations: ['RIGHT_HAND', 'LEFT_HAND'],
  },
  {
    key: 'AVULSION_NOSE',
    category: 'AVULSION',
    variation: 'AVULSION',
    label: { en: 'Avulsion', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AVULSION/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AVULSION/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: ['NOSE'],
  },
  {
    key: 'ABRASION_SEVERE_SMALL',
    category: 'ABRASION',
    variation: 'SEVERE',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/ABRASION_SEVERE_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/ABRASION_SEVERE_SMALL/thumbs/${location}.png',
    },
    displayOrder: 0,
    locations: [
      'HEAD',
      'FACE',
      'NECK',
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'ABRASION_MODERATE_SMALL',
    category: 'ABRASION',
    variation: 'MODERATE',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/ABRASION_MODERATE_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/ABRASION_MODERATE_SMALL/thumbs/${location}.png',
    },
    displayOrder: 0,
    locations: [
      'HEAD',
      'FACE',
      'NECK',
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'DISTENSION_MEDIUM',
    category: 'GASTRIC DISTENSION',
    variation: 'MEDIUM',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/DISTENSION_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/DISTENSION_MEDIUM/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 1,
    locations: ['ABDOMEN'],
    bodyTypeRestrictions: {
      'ABDOMEN': 'OBESE'
    },
    stanceRestrictions: {
      'ABDOMEN': [ 'PRONE' ]
    },
  },
  {
    key: 'DEGLOVING',
    category: 'DEGLOVING',
    variation: 'DEGLOVING',
    label: { en: 'Degloving', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/DEGLOVING/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/DEGLOVING/thumbs/${location}.png',
    },
    isStructural: false,
    structuralOverride: {
      // Degloving feet needs to be structural.  This is the least objectionable way to handle that.
      'RIGHT_FOOT': true,
      'LEFT_FOOT': true,
    },
    displayOrder: 0,
    locations: ['RIGHT_HAND', 'LEFT_HAND', 'RIGHT_FOOT', 'LEFT_FOOT'],
  },
  {
    key: 'FRACTURE_CLOSED_LOWER',
    category: 'FRACTURE',
    variation: 'CLOSED',
    label: { en: 'Closed Fracture', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/FRACTURE_CLOSED_LOWER/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/FRACTURE_CLOSED_LOWER/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 0,
    locations: [
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_LOWER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_LOWER',
    ],
    stanceRestrictions: {
      'LEFT_LEG_LOWER': [ 'SIDE', 'PRONE' ]
    },
  },
  {
    key: 'DISTENSION_SMALL',
    category: 'GASTRIC DISTENSION',
    variation: 'SMALL',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/DISTENSION_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/DISTENSION_SMALL/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 0,
    locations: ['ABDOMEN'],
    bodyTypeRestrictions: {
      'ABDOMEN': 'OBESE'
    },
    stanceRestrictions: {
      'ABDOMEN': [ 'PRONE' ]
    },
  },
  {
    key: 'FRACTURE_CLOSED_UPPER',
    category: 'FRACTURE',
    variation: 'CLOSED',
    label: { en: 'Closed Fracture', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/FRACTURE_CLOSED_UPPER/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/FRACTURE_CLOSED_UPPER/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 0,
    locations: [
      'RIGHT_ARM_UPPER',
      'LEFT_ARM_UPPER',
      'RIGHT_LEG_UPPER',
      'LEFT_LEG_UPPER',
    ],
    stanceRestrictions: {
      'LEFT_LEG_UPPER': [ 'SIDE', 'PRONE' ]
    },
    bodyTypeRestrictions: {
      'RIGHT_LEG_UPPER': 'OBESE',
      'LEFT_LEG_UPPER': 'OBESE',
    }
  },
  {
    key: 'AVULSION_EAR',
    category: 'AVULSION',
    variation: 'AVULSION',
    label: { en: 'Avulsion', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AVULSION/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AVULSION/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 0,
    locations: ['EARS'],
  },
  {
    key: 'ABRASION_MODERATE_LARGE',
    category: 'ABRASION',
    variation: 'MODERATE',
    label: { en: 'Large', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/ABRASION_MODERATE_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/ABRASION_MODERATE_LARGE/thumbs/${location}.png',
    },
    displayOrder: 2,
    locations: [
      'HEAD',
      'FACE',
      'NECK',
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'ABRASION_MODERATE_MEDIUM',
    category: 'ABRASION',
    variation: 'MODERATE',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/ABRASION_MODERATE_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/ABRASION_MODERATE_MEDIUM/thumbs/${location}.png',
    },
    displayOrder: 1,
    locations: [
      'HEAD',
      'FACE',
      'NECK',
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'FRACTURE_CLOSED_EXTREMITY',
    category: 'FRACTURE',
    variation: 'CLOSED',
    label: { en: 'Closed Fracture', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/FRACTURE_CLOSED_EXTREMITY/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/FRACTURE_CLOSED_EXTREMITY/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 0,
    locations: ['RIGHT_HAND', 'LEFT_HAND', 'RIGHT_FOOT', 'LEFT_FOOT'],
    stanceRestrictions: {
      'LEFT_FOOT': [ 'SIDE', 'PRONE' ]
    },
  },
  {
    key: 'EPISTAXIS_LARGE',
    category: 'EPISTAXIS',
    variation: 'EPISTAXIS',
    label: { en: 'Large', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/EPISTAXIS_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/EPISTAXIS_LARGE/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 2,
    locations: ['NOSE'],
  },
  {
    key: 'EPISTAXIS_MEDIUM',
    category: 'EPISTAXIS',
    variation: 'EPISTAXIS',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/EPISTAXIS_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/EPISTAXIS_MEDIUM/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 1,
    locations: ['NOSE'],
  },
  {
    key: 'EPISTAXIS_SMALL',
    category: 'EPISTAXIS',
    variation: 'EPISTAXIS',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/EPISTAXIS_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/EPISTAXIS_SMALL/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: ['NOSE'],
  },
  {
    key: 'GSW_ENTRY_SMALL',
    category: 'GUNSHOT_WOUND',
    variation: 'ENTRY',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_ENTRY_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_ENTRY_SMALL/thumbs/${location}.png',
    },
    displayOrder: 0,
    locations: [
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'GSW_ENTRY_MEDIUM',
    category: 'GUNSHOT_WOUND',
    variation: 'ENTRY',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_ENTRY_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_ENTRY_MEDIUM/thumbs/${location}.png',
    },
    displayOrder: 1,
    locations: [
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'GSW_MULTIPLE_SMALL',
    category: 'GUNSHOT_WOUND',
    variation: 'MULTIPLE',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_MULTIPLE_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_MULTIPLE_SMALL/thumbs/${location}.png',
    },
    displayOrder: 0,
    locations: ['CHEST', 'ABDOMEN', 'BACK_UPPER', 'BACK_LOWER'],
  },
  {
    key: 'GSW_MULTIPLE_MEDIUM',
    category: 'GUNSHOT_WOUND',
    variation: 'MULTIPLE',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_MULTIPLE_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_MULTIPLE_MEDIUM/thumbs/${location}.png',
    },
    displayOrder: 1,
    locations: ['CHEST', 'ABDOMEN', 'BACK_UPPER', 'BACK_LOWER'],
  },
  {
    key: 'GSW_ENTRY_AND_EXIT_SMALL',
    category: 'GUNSHOT_WOUND',
    variation: 'ENTRY_AND_EXIT',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_ENTRY_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_ENTRY_SMALL/thumbs/${location}.png',
    },
    displayOrder: 0,
    physicalRepercussions: [
      {
        type: 'FORCED_MOULAGE',
        location: '_OPPOSITE_',
        metadata: {
          moulage: {
            key: 'GSW_EXIT_SMALL',
            category: 'GUNSHOT_WOUND',
            variation: 'EXIT',
            label: { en: 'Small', es: '' },
            picture: {
              url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_EXIT_SMALL/${location}.png',
            },
            thumbnail: {
              url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_EXIT_SMALL/thumbs/${location}.png',
            },
          },
        },
      },
    ],
    locations: [
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'GSW_ENTRY_AND_EXIT_MEDIUM',
    category: 'GUNSHOT_WOUND',
    variation: 'ENTRY_AND_EXIT',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_ENTRY_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_ENTRY_MEDIUM/thumbs/${location}.png',
    },
    displayOrder: 1,
    physicalRepercussions: [
      {
        type: 'FORCED_MOULAGE',
        location: '_OPPOSITE_',
        metadata: {
          moulage: {
            key: 'GSW_EXIT_SMALL',
            category: 'GUNSHOT_WOUND',
            variation: 'EXIT',
            label: { en: 'Medium', es: '' },
            picture: {
              url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_EXIT_MEDIUM/${location}.png',
            },
            thumbnail: {
              url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/GUNSHOT_WOUND_EXIT_MEDIUM/thumbs/${location}.png',
            },
          },
        },
      },
    ],
    locations: [
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'LACERATION_SMALL',
    category: 'LACERATION',
    variation: 'LACERATION',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/LACERATION_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/LACERATION_SMALL/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'HEAD',
      'FACE',
      'NECK',
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
      'BUTTOCKS',
    ],
  },
  {
    key: 'LACERATION_MEDIUM',
    category: 'LACERATION',
    variation: 'LACERATION',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/LACERATION_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/LACERATION_MEDIUM/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 1,
    locations: [
      'HEAD',
      'FACE',
      'NECK',
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
      'BUTTOCKS',
    ],
  },
  {
    key: 'LACERATION_LARGE',
    category: 'LACERATION',
    variation: 'LACERATION',
    label: { en: 'Large', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/LACERATION_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/LACERATION_LARGE/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 2,
    locations: [
      'HEAD',
      'FACE',
      'NECK',
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'BUTTOCKS',
    ],
  },
  {
    key: 'LACERATION_SMALL_2',
    category: 'LACERATION',
    variation: 'ALTERNATE',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/LACERATION_SMALL_2/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/LACERATION_SMALL_2/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 4,
    locations: ['HEAD', 'NECK'],
  },
  {
    key: 'LACERATION_MEDIUM_2',
    category: 'LACERATION',
    variation: 'ALTERNATE',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/LACERATION_MEDIUM_2/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/LACERATION_MEDIUM_2/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 5,
    locations: ['HEAD', 'NECK'],
  },
  {
    key: 'LACERATION_LARGE_2',
    category: 'LACERATION',
    variation: 'ALTERNATE',
    label: { en: 'Large', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/LACERATION_LARGE_2/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/LACERATION_LARGE_2/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 6,
    locations: ['HEAD', 'NECK'],
  },
  {
    key: 'BURN_1ST_DEGREE_LARGE',
    category: 'BURN',
    variation: 'BURN',
    label: { en: '1st Degree', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BURN_1ST_DEGREE_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BURN_1ST_DEGREE_LARGE/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'HEAD',
      'FACE',
      'NECK',
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'BURN_2ND_DEGREE_LARGE',
    category: 'BURN',
    variation: 'BURN',
    label: { en: '2nd Degree', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BURN_2ND_DEGREE_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BURN_2ND_DEGREE_LARGE/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 1,
    locations: [
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'BURN_3RD_DEGREE_LARGE',
    category: 'BURN',
    variation: 'BURN',
    label: { en: '3rd Degree', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BURN_3RD_DEGREE_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BURN_3RD_DEGREE_LARGE/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 3,
    locations: [
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'BURN_2ND_DEGREE_SPLATTER',
    category: 'BURN',
    variation: 'BURN',
    label: { en: '2nd Degree Splatter', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BURN_2ND_DEGREE_SPLATTER/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BURN_2ND_DEGREE_SPLATTER/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 2,
    locations: [
      'HEAD',
      'FACE',
      'NECK',
      'CHEST',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'BURN_4TH_DEGREE_LARGE',
    category: 'BURN',
    variation: 'BURN',
    label: { en: '4th Degree', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BURN_4TH_DEGREE_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BURN_4TH_DEGREE_LARGE/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 4,
    locations: [
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
  },
  {
    key: 'STABBING_SMALL',
    category: 'STABBING',
    variation: 'STABBING',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/STABBING_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/STABBING_SMALL/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 1,
    locations: [
      'FACE',
      'NECK',
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'LEFT_ARM_UPPER',
      'RIGHT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_ARM_LOWER',
      'LEFT_HAND',
      'RIGHT_HAND',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'LEFT_LEG_UPPER',
      'RIGHT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_LEG_LOWER',
      'LEFT_FOOT',
      'RIGHT_FOOT',
    ],
  },
  {
    key: 'STABBING_MEDIUM',
    category: 'STABBING',
    variation: 'STABBING',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/STABBING_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/STABBING_MEDIUM/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 2,
    locations: [
      'FACE',
      'NECK',
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'LEFT_ARM_UPPER',
      'RIGHT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_ARM_LOWER',
      'LEFT_HAND',
      'RIGHT_HAND',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'LEFT_LEG_UPPER',
      'RIGHT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_LEG_LOWER',
      'LEFT_FOOT',
      'RIGHT_FOOT',
    ],
  },
  {
    key: 'STABBING_BRUISED_SMALL',
    category: 'STABBING',
    variation: 'BRUISED',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/STABBING_BRUISED_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/STABBING_BRUISED_SMALL/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 1,
    locations: [
      'FACE',
      'NECK',
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'LEFT_ARM_UPPER',
      'RIGHT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_ARM_LOWER',
      'LEFT_HAND',
      'RIGHT_HAND',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'LEFT_LEG_UPPER',
      'RIGHT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_LEG_LOWER',
      'LEFT_FOOT',
      'RIGHT_FOOT',
    ],
  },
  {
    key: 'STABBING_BRUISED_MEDIUM',
    category: 'STABBING',
    variation: 'BRUISED',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/STABBING_BRUISED_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/STABBING_BRUISED_MEDIUM/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 2,
    locations: [
      'FACE',
      'NECK',
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'LEFT_ARM_UPPER',
      'RIGHT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_ARM_LOWER',
      'LEFT_HAND',
      'RIGHT_HAND',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'LEFT_LEG_UPPER',
      'RIGHT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_LEG_LOWER',
      'LEFT_FOOT',
      'RIGHT_FOOT',
    ],
  },
  {
    key: 'STABBING_SMALL_CLUSTER',
    category: 'STABBING',
    variation: 'SMALL_CLUSTER',
    label: { en: 'Small Cluster', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/STABBING_SMALL_CLUSTER/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/STABBING_SMALL_CLUSTER/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 1,
    locations: ['CHEST', 'ABDOMEN', 'BACK_UPPER', 'BACK_LOWER'],
  },
  {
    key: 'CONTUSION_FRESH_SMALL',
    category: 'CONTUSION',
    variation: 'FRESH',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/CONTUSION_FRESH_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/CONTUSION_FRESH_SMALL/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 1,
    locations: [
      'FACE',
      'NECK',
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'LEFT_ARM_UPPER',
      'RIGHT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_ARM_LOWER',
      'LEFT_HAND',
      'RIGHT_HAND',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'LEFT_LEG_UPPER',
      'RIGHT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_LEG_LOWER',
      'LEFT_FOOT',
      'RIGHT_FOOT',
    ],
  },
  {
    key: 'CONTUSION_FRESH_MEDIUM',
    category: 'CONTUSION',
    variation: 'FRESH',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/CONTUSION_FRESH_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/CONTUSION_FRESH_MEDIUM/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 2,
    locations: [
      'FACE',
      'NECK',
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'LEFT_ARM_UPPER',
      'RIGHT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_ARM_LOWER',
      'LEFT_HAND',
      'RIGHT_HAND',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'LEFT_LEG_UPPER',
      'RIGHT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_LEG_LOWER',
      'LEFT_FOOT',
      'RIGHT_FOOT',
    ],
  },
  {
    key: 'CONTUSION_FRESH_LARGE',
    category: 'CONTUSION',
    variation: 'FRESH',
    label: { en: 'Large', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/CONTUSION_FRESH_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/CONTUSION_FRESH_LARGE/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 3,
    locations: [
      'FACE',
      'NECK',
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'LEFT_ARM_UPPER',
      'RIGHT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_ARM_LOWER',
      'LEFT_HAND',
      'RIGHT_HAND',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'LEFT_LEG_UPPER',
      'RIGHT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_LEG_LOWER',
      'LEFT_FOOT',
      'RIGHT_FOOT',
    ],
  },
  {
    key: 'CONTUSION_HEALING_SMALL',
    category: 'CONTUSION',
    variation: 'HEALING',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/CONTUSION_HEALING_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/CONTUSION_HEALING_SMALL/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 1,
    locations: [
      'FACE',
      'NECK',
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'LEFT_ARM_UPPER',
      'RIGHT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_ARM_LOWER',
      'LEFT_HAND',
      'RIGHT_HAND',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'LEFT_LEG_UPPER',
      'RIGHT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_LEG_LOWER',
      'LEFT_FOOT',
      'RIGHT_FOOT',
    ],
  },
  {
    key: 'CONTUSION_HEALING_MEDIUM',
    category: 'CONTUSION',
    variation: 'HEALING',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/CONTUSION_HEALING_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/CONTUSION_HEALING_MEDIUM/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 2,
    locations: [
      'FACE',
      'NECK',
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'LEFT_ARM_UPPER',
      'RIGHT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_ARM_LOWER',
      'LEFT_HAND',
      'RIGHT_HAND',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'LEFT_LEG_UPPER',
      'RIGHT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_LEG_LOWER',
      'LEFT_FOOT',
      'RIGHT_FOOT',
    ],
  },
  {
    key: 'CONTUSION_HEALING_LARGE',
    category: 'CONTUSION',
    variation: 'HEALING',
    label: { en: 'Large', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/CONTUSION_HEALING_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/CONTUSION_HEALING_LARGE/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 3,
    locations: [
      'FACE',
      'NECK',
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'LEFT_ARM_UPPER',
      'RIGHT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_ARM_LOWER',
      'LEFT_HAND',
      'RIGHT_HAND',
      'BACK_UPPER',
      'BACK_LOWER',
      'GENITALIA',
      'LEFT_LEG_UPPER',
      'RIGHT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_LEG_LOWER',
      'LEFT_FOOT',
      'RIGHT_FOOT',
    ],
  },
  {
    key: 'BLEEDING_SMALL',
    category: 'BLEEDING',
    variation: 'BLEEDING',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BLEEDING_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BLEEDING_SMALL/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 1,
    locations: [
      'MOUTH'
    ],
  },
  {
    key: 'BLEEDING_MEDIUM',
    category: 'BLEEDING',
    variation: 'BLEEDING',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BLEEDING_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/BLEEDING_MEDIUM/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 2,
    locations: [
      'MOUTH'
    ],
  },
  {
    key: 'OTORRHEA_MEDIUM',
    category: 'OTORRHEA',
    variation: 'OTORRHEA',
    label: { en: 'Left', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/OTORRHEA_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/OTORRHEA_MEDIUM/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'EARS'
    ],
  },
  {
    key: 'OTORRHEA_MEDIUM_2',
    category: 'OTORRHEA',
    variation: 'OTORRHEA',
    label: { en: 'Right', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/OTORRHEA_MEDIUM_2/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/OTORRHEA_MEDIUM_2/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 1,
    locations: [
      'EARS'
    ],
  },
  {
    key: 'EDEMA_MEDIUM',
    category: 'EDEMA',
    variation: 'EDEMA',
    label: { en: 'Moderate', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/EDEMA_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/EDEMA_MEDIUM/thumbs/${location}.png',
    },
    displayOrder: 0,
    locations: ['LEFT_ARM_UPPER', 'RIGHT_ARM_UPPER', 'LEFT_LEG_UPPER', 'RIGHT_LEG_UPPER'],
    isStructural: true,
  },
  {
    key: 'EDEMA_LARGE',
    category: 'EDEMA',
    variation: 'EDEMA',
    label: { en: 'Severe', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/EDEMA_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/EDEMA_LARGE/thumbs/${location}.png',
    },
    displayOrder: 1,
    locations: ['LEFT_ARM_UPPER', 'RIGHT_ARM_UPPER', 'LEFT_LEG_UPPER', 'RIGHT_LEG_UPPER'],
    isStructural: true,
  },
  {
    key: 'RACCOON_EYES',
    category: 'RACCOON_EYES',
    variation: 'RACCOON_EYES',
    label: { en: 'Racoon Eyes', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/RACCOON_EYES/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/RACCOON_EYES/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'EYES'
    ],
  },
  {
    key: 'PETECHIAE',
    category: 'PETECHIAE',
    variation: 'PETECHIAE',
    label: { en: 'Petechiae', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/PETECHIAE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/PETECHIAE/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'ABDOMEN',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'BUTTOCKS',
    ],
  },
  {
    key: 'PURPURA',
    category: 'PURPURA',
    variation: 'PURPURA',
    label: { en: 'Purpura', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/PURPURA/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/PURPURA/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'ABDOMEN',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'BUTTOCKS',
    ],
  },
  {
    key: 'WHEAL_MEDIUM',
    category: 'WHEAL',
    variation: 'WHEAL',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/WHEAL_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/WHEAL_MEDIUM/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'ABDOMEN',
      'BACK_LOWER',
      'BACK_UPPER',
      'BUTTOCKS',
      'CHEST',
      'FACE',
      'GENITALIA',
      'LEFT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_FOOT',
      'LEFT_HAND',
      'LEFT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'NECK',
      'RIGHT_ARM_LOWER',
      'RIGHT_ARM_UPPER',
      'RIGHT_FOOT',
      'RIGHT_HAND',
      'RIGHT_LEG_LOWER',
      'RIGHT_LEG_UPPER',
    ],
  },
  {
    key: 'WHEAL_LARGE',
    category: 'WHEAL',
    variation: 'WHEAL',
    label: { en: 'Large', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/WHEAL_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/WHEAL_LARGE/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'ABDOMEN',
      'BACK_LOWER',
      'BACK_UPPER',
      'BUTTOCKS',
      'CHEST',
      'FACE',
      'GENITALIA',
      'LEFT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_FOOT',
      'LEFT_HAND',
      'LEFT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'NECK',
      'RIGHT_ARM_LOWER',
      'RIGHT_ARM_UPPER',
      'RIGHT_FOOT',
      'RIGHT_HAND',
      'RIGHT_LEG_LOWER',
      'RIGHT_LEG_UPPER',
    ],
  },
  {
    key: 'URTICARIA_BLOTCHY_SMALL',
    category: 'URTICARIA',
    variation: 'BLOTCHY',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/URTICARIA_BLOTCHY_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/URTICARIA_BLOTCHY_SMALL/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'ABDOMEN',
      'BACK_LOWER',
      'BACK_UPPER',
      'CHEST',
      'FACE',
      'GENITALIA',
      'HEAD',
      'LEFT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_FOOT',
      'LEFT_HAND',
      'LEFT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'NECK',
      'RIGHT_ARM_LOWER',
      'RIGHT_ARM_UPPER',
      'RIGHT_FOOT',
      'RIGHT_HAND',
      'RIGHT_LEG_LOWER',
      'RIGHT_LEG_UPPER',
    ],
  },
  {
    key: 'URTICARIA_BLOTCHY_MEDIUM',
    category: 'URTICARIA',
    variation: 'BLOTCHY',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/URTICARIA_BLOTCHY_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/URTICARIA_BLOTCHY_MEDIUM/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'ABDOMEN',
      'BACK_LOWER',
      'BACK_UPPER',
      'CHEST',
      'FACE',
      'GENITALIA',
      'HEAD',
      'LEFT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_FOOT',
      'LEFT_HAND',
      'LEFT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'NECK',
      'RIGHT_ARM_LOWER',
      'RIGHT_ARM_UPPER',
      'RIGHT_FOOT',
      'RIGHT_HAND',
      'RIGHT_LEG_LOWER',
      'RIGHT_LEG_UPPER',
    ],
  },
  {
    key: 'URTICARIA_BLOTCHY_LARGE',
    category: 'URTICARIA',
    variation: 'BLOTCHY',
    label: { en: 'Large', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/URTICARIA_BLOTCHY_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/URTICARIA_BLOTCHY_LARGE/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'ABDOMEN',
      'BACK_LOWER',
      'BACK_UPPER',
      'CHEST',
      'FACE',
      'GENITALIA',
      'HEAD',
      'LEFT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'NECK',
      'RIGHT_ARM_LOWER',
      'RIGHT_ARM_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_LEG_UPPER',
    ],
  },
  {
    key: 'URTICARIA_DENSE_SMALL',
    category: 'URTICARIA',
    variation: 'DENSE',
    label: { en: 'Small', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/URTICARIA_DENSE_SMALL/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/URTICARIA_DENSE_SMALL/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'ABDOMEN',
      'BACK_LOWER',
      'BACK_UPPER',
      'CHEST',
      'FACE',
      'GENITALIA',
      'HEAD',
      'LEFT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_FOOT',
      'LEFT_HAND',
      'LEFT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'NECK',
      'RIGHT_ARM_LOWER',
      'RIGHT_ARM_UPPER',
      'RIGHT_FOOT',
      'RIGHT_HAND',
      'RIGHT_LEG_LOWER',
      'RIGHT_LEG_UPPER',
    ],
  },
  {
    key: 'URTICARIA_DENSE_MEDIUM',
    category: 'URTICARIA',
    variation: 'DENSE',
    label: { en: 'Medium', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/URTICARIA_DENSE_MEDIUM/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/URTICARIA_DENSE_MEDIUM/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'ABDOMEN',
      'BACK_LOWER',
      'BACK_UPPER',
      'CHEST',
      'FACE',
      'GENITALIA',
      'HEAD',
      'LEFT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_FOOT',
      'LEFT_HAND',
      'LEFT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'NECK',
      'RIGHT_ARM_LOWER',
      'RIGHT_ARM_UPPER',
      'RIGHT_FOOT',
      'RIGHT_HAND',
      'RIGHT_LEG_LOWER',
      'RIGHT_LEG_UPPER',
    ],
  },
  {
    key: 'URTICARIA_DENSE_LARGE',
    category: 'URTICARIA',
    variation: 'DENSE',
    label: { en: 'Large', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/URTICARIA_DENSE_LARGE/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/URTICARIA_DENSE_LARGE/thumbs/${location}.png',
    },
    isStructural: false,
    displayOrder: 0,
    locations: [
      'ABDOMEN',
      'BACK_LOWER',
      'BACK_UPPER',
      'CHEST',
      'FACE',
      'GENITALIA',
      'HEAD',
      'LEFT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'NECK',
      'RIGHT_ARM_LOWER',
      'RIGHT_ARM_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_LEG_UPPER',
    ],
  },
  {
    key: 'AMPUTATION_CLEAN_UPPER',
    category: 'AMPUTATION',
    variation: 'CLEAN',
    label: { en: 'Clean', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_CLEAN_UPPER/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_CLEAN_UPPER/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 0,
    locations: [
      'LEFT_ARM_UPPER',
      'LEFT_LEG_UPPER',
      'RIGHT_ARM_UPPER',
      'RIGHT_LEG_UPPER',
    ],
    stanceRestrictions: {
      'ANY': ['SIT', 'SIDE', 'PRONE']
    },
  },
  {
    key: 'AMPUTATION_CLEAN_LOWER',
    category: 'AMPUTATION',
    variation: 'CLEAN',
    label: { en: 'Clean', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_CLEAN_LOWER/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_CLEAN_LOWER/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 0,
    locations: [
      'LEFT_ARM_LOWER',
      'LEFT_LEG_LOWER',
      'RIGHT_ARM_LOWER',
      'RIGHT_LEG_LOWER',
    ],
    stanceRestrictions: {
      'ANY': ['SIT', 'SIDE', 'PRONE']
    },
  },
  {
    key: 'AMPUTATION_CLEAN_EXTREMITY',
    category: 'AMPUTATION',
    variation: 'CLEAN',
    label: { en: 'Clean', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_CLEAN_EXTREMITY/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_CLEAN_EXTREMITY/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 0,
    locations: [
      'LEFT_FOOT',
      'LEFT_HAND',
      'RIGHT_FOOT',
      'RIGHT_HAND',
    ],
    stanceRestrictions: {
      'ANY': ['SIT', 'SIDE', 'PRONE']
    },
  },
  {
    key: 'AMPUTATION_MESSY_UPPER',
    category: 'AMPUTATION',
    variation: 'MESSY',
    label: { en: 'Messy', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_MESSY_UPPER/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_MESSY_UPPER/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 1,
    locations: [
      'LEFT_ARM_UPPER',
      'LEFT_LEG_UPPER',
      'RIGHT_ARM_UPPER',
      'RIGHT_LEG_UPPER',
    ],
    stanceRestrictions: {
      'ANY': ['SIT', 'SIDE', 'PRONE']
    },
  },
  {
    key: 'AMPUTATION_MESSY_LOWER',
    category: 'AMPUTATION',
    variation: 'MESSY',
    label: { en: 'Messy', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_MESSY_LOWER/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_MESSY_LOWER/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 1,
    locations: [
      'LEFT_ARM_LOWER',
      'LEFT_LEG_LOWER',
      'RIGHT_ARM_LOWER',
      'RIGHT_LEG_LOWER',
    ],
    stanceRestrictions: {
      'ANY': ['SIT', 'SIDE', 'PRONE']
    },
  },
  {
    key: 'AMPUTATION_MESSY_EXTREMITY',
    category: 'AMPUTATION',
    variation: 'MESSY',
    label: { en: 'Messy', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_MESSY_EXTREMITY/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_MESSY_EXTREMITY/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 1,
    locations: [
      'LEFT_FOOT',
      'LEFT_HAND',
      'RIGHT_FOOT',
      'RIGHT_HAND',
    ],
    stanceRestrictions: {
      'ANY': ['SIT', 'SIDE', 'PRONE']
    },
  },
  {
    key: 'AMPUTATION_BLAST_UPPER',
    category: 'AMPUTATION',
    variation: 'BLAST',
    label: { en: 'Blast', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_BLAST_UPPER/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_BLAST_UPPER/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 2,
    locations: [
      'LEFT_ARM_UPPER',
      'LEFT_LEG_UPPER',
      'RIGHT_ARM_UPPER',
      'RIGHT_LEG_UPPER',
    ],
    stanceRestrictions: {
      'ANY': ['SIT', 'SIDE', 'PRONE']
    },
  },
  {
    key: 'AMPUTATION_BLAST_LOWER',
    category: 'AMPUTATION',
    variation: 'BLAST',
    label: { en: 'Blast', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_BLAST_LOWER/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_BLAST_LOWER/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 2,
    locations: [
      'LEFT_ARM_LOWER',
      'LEFT_LEG_LOWER',
      'RIGHT_ARM_LOWER',
      'RIGHT_LEG_LOWER',
    ],
    stanceRestrictions: {
      'ANY': ['SIT', 'SIDE', 'PRONE']
    },
  },
  {
    key: 'AMPUTATION_BLAST_EXTREMITY',
    category: 'AMPUTATION',
    variation: 'BLAST',
    label: { en: 'Blast', es: '' },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_BLAST_EXTREMITY/${location}.png',
    },
    thumbnail: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/moulages/${avatar}/AMPUTATION_BLAST_EXTREMITY/thumbs/${location}.png',
    },
    isStructural: true,
    displayOrder: 2,
    locations: [
      'LEFT_FOOT',
      'LEFT_HAND',
      'RIGHT_FOOT',
      'RIGHT_HAND',
    ],
    stanceRestrictions: {
      'ANY': ['SIT', 'SIDE', 'PRONE']
    },
  },
];
